import {
  SET_ANIMATION_CLIENT_FB_LIST,
  SET_ANIMATION_CLIENT_FB_PAGE_NUM,
  SET_ANIMATION_CLIENT_FB_PAGE_SIZE,
  SET_ANIMATION_CLIENT_FB_PAGE_SIZE_TOTAL,
  SET_ANIMATION_CLIENT_FB_QUERY,
  SET_ANIMATION_CLIENT_FB_SEARCHING,
} from './mutation-types.js'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageSize: 20,
  pageNum: 1,
  userName: '',
  userId: '',
  score: '',
  version: '',
  startDate: new Date().setMonth(new Date().getMonth() - 1),
  endDate: new Date().setHours(23, 59, 59, 999),
  channel: '', //  2: 动画客户端 3：FOX动画版客户端
})

const state = {
  searching: false,
  initQuery: initQuery(),
  animationClientFeedback: {
    list: [],
    listPagTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_ANIMATION_CLIENT_FB_LIST] (state, payload) {
    state.animationClientFeedback.list = payload
  },
  [SET_ANIMATION_CLIENT_FB_PAGE_NUM] (state, payload) {
    state.animationClientFeedback.query.pageNum = payload
  },
  [SET_ANIMATION_CLIENT_FB_PAGE_SIZE] (state, payload) {
    state.animationClientFeedback.query.pageSize = payload
  },
  [SET_ANIMATION_CLIENT_FB_PAGE_SIZE_TOTAL] (state, payload) {
    state.animationClientFeedback.listPageTotal = payload
  },
  [SET_ANIMATION_CLIENT_FB_QUERY] (state, payload) {
    state.animationClientFeedback.query = {
      ...state.animationClientFeedback.query,
      ...payload,
    }
  },
  [SET_ANIMATION_CLIENT_FB_SEARCHING](state, payload) {
    state.searching = payload
  },
}

const actions = {
  async getAnimationClientFb({commit, state}, payload) {
    try {
      commit(SET_ANIMATION_CLIENT_FB_SEARCHING, true)
      let query = {}
      _.forIn(state.animationClientFeedback.query, (v, k) => {
        if ((v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
          query[k] = v
        }
      })
      let params = {
        ...query,
        ...payload,
      }
      let {data: {items, total}} = await api.userApi.queryClientFeedback(params)
      commit(SET_ANIMATION_CLIENT_FB_SEARCHING, false)
      commit(SET_ANIMATION_CLIENT_FB_LIST, items)
      commit(SET_ANIMATION_CLIENT_FB_PAGE_SIZE_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_ANIMATION_CLIENT_FB_SEARCHING, false)
      commit(SET_ANIMATION_CLIENT_FB_PAGE_SIZE_TOTAL, 0)
      commit(SET_ANIMATION_CLIENT_FB_LIST, [])
    }
  },
  setAnimationClientFbQuery ({commit}, payload) {
    commit(SET_ANIMATION_CLIENT_FB_QUERY, payload)
  },
  async initAnimationClientFb ({dispatch}) {
    await dispatch('setAnimationClientFbQuery', state.initQuery)
    await dispatch('getAnimationClientFb')
  },
  // // 改变每页显示条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_ANIMATION_CLIENT_FB_PAGE_SIZE, payload.pageSize)
    commit(SET_ANIMATION_CLIENT_FB_PAGE_NUM, 1)
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_ANIMATION_CLIENT_FB_PAGE_NUM, payload.currentPage)
  },
  async queryFeedbackVersions({commit, dispatch, state}, payload) {
    const { code, data } = await api.userApi.queryFeedbackVersions({})
    if (code === 200) {
      return data
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
